import { SelectOption } from '../classes'
import { FRONTEND_ELIGIBILITY_STATUS } from '../utils/frontend-eligibility-status'

export const EligibilityStatuses: SelectOption<string>[] = [
  {
    value: FRONTEND_ELIGIBILITY_STATUS.ACTIVE,
    viewValue: 'statuses.eligibilities.active',
  },
  {
    value: FRONTEND_ELIGIBILITY_STATUS.COVERAGE_MISMATCH,
    viewValue: 'statuses.eligibilities.coverage-mismatch',
  },
  {
    value: FRONTEND_ELIGIBILITY_STATUS.STATUS_MISMATCH,
    viewValue: 'statuses.eligibilities.status-mismatch',
  },
  {
    value: FRONTEND_ELIGIBILITY_STATUS.CONNECTIVITY_ISSUES,
    viewValue: 'statuses.eligibilities.connectivity-issues',
  },
  {
    value: FRONTEND_ELIGIBILITY_STATUS.USER_INTERVENTION,
    viewValue: 'statuses.eligibilities.user-intervention',
  },
]
